/* eslint-disable */
/* tslint:disable */
/* Do not edit - generated by swagger-typescript-api */

import {
  Condition,
  ErrorResponse,
  SkuClassResponseCollectionResponse,
  Sorting,
} from './data-contracts';
import { HttpClient, RequestParams } from './http-client';
export class SkuClasses<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;
  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }
  /**
   * No description
   *
   * @tags SkuClasses
   * @name SkuClassesList
   * @request GET:/SkuClasses
   * @response `200` `SkuClassResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  skuClassesList = (
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<SkuClassResponseCollectionResponse, ErrorResponse>({
      path: `/SkuClasses`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
}
